// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('TextureElementVO')
export class TextureElementVO {
  public static readonly TEXTURE_ELEMENT_PREFIX: string = 'tx';

  @JsonProperty('name', 'String')
  public name: string = undefined;

  @JsonProperty('imageFileName', 'String')
  public imageFileName: string = undefined;

  @JsonProperty('scale', 'Number')
  public scale: number = undefined;

  @JsonProperty('positionX', 'Number')
  public positionX: number = undefined;

  @JsonProperty('positionY', 'Number')
  public positionY: number = undefined;

  @JsonProperty('positionZ', 'Number')
  public positionZ: number = undefined;

  @JsonProperty('rotationX', 'Number')
  public rotationX: number = undefined;

  @JsonProperty('rotationY', 'Number')
  public rotationY: number = undefined;

  @JsonProperty('rotationZ', 'Number')
  public rotationZ: number = undefined;

  public constructor(name: string, imageFileName: string) {
    this.name = name;
    this.imageFileName = imageFileName;
    this.scale = 1;
    this.positionX = 0;
    this.positionY = 0;
    this.positionZ = 0;
    this.rotationX = 0;
    this.rotationY = 0;
    this.rotationZ = 0;
  }
}
